import { KeyboardArrowDown } from '@mui/icons-material';
import { Accordion, AccordionDetails, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { convertReadableFormatDate } from 'shared/lib/convertDate/convertDate';
import { AccordionHeader } from 'shared/ui/AccordionHeader/AccordionHeader';

import { ContactRow } from './ContactRow';

import { Shipment } from '../../model/types/SupplierCard';

interface SupplierShipmentSectionProps {
    shipments: Shipment[];
}

export const SupplierShipmentSection = ({
    shipments,
}: SupplierShipmentSectionProps) => {
    const { t } = useTranslation();

    const shipmentsCount = shipments?.length ?? 0;

    if (shipmentsCount === 0) {
        return null;
    }

    return (
        <Accordion
            data-testclass="supplier-card-shipment-section"
            sx={{
                bgcolor: 'transparent',
                boxShadow: 'none',
                '&:before': {
                    display: 'none',
                },
            }}
            defaultExpanded={false}
        >
            <AccordionHeader
                title={shipmentsCount > 1 ? t('Shipments') : t('Shipment')}
                expandIcon={
                    <KeyboardArrowDown
                        sx={{
                            color: 'grey.600',
                        }}
                    />
                }
                sx={{
                    px: 0,
                    mb: 0,
                    '& .MuiTypography-root': {
                        color: 'grey.600',
                        fontSize: '14px',
                        fontWeight: 700,
                        letterSpacing: '0.5px',
                        textTransform: 'uppercase',
                    },
                }}
            />
            <AccordionDetails sx={{ mt: '8px' }}>
                {shipments.map((shipment, index) => (
                    <Box
                        key={`shipment-${shipment.order ?? index}_${index}`}
                        sx={{
                            mb: '20px',
                            '&:last-child': {
                                marginBottom: 0,
                            },
                        }}
                    >
                        {shipmentsCount === 1 && (
                            <>
                                <ContactRow
                                    label={t('Order')}
                                    value={shipment.order || '-'}
                                    wrap
                                />
                                <ContactRow
                                    label={t('Shipped')}
                                    value={
                                        convertReadableFormatDate(
                                            shipment.shipped,
                                            {
                                                month: 'long',
                                            },
                                        ) || '-'
                                    }
                                />
                                <ContactRow
                                    label={t('Carrier')}
                                    value={shipment.carrier || '-'}
                                />
                            </>
                        )}

                        {shipmentsCount > 1 && (
                            <>
                                <Typography
                                    typography="openSans.body2Medium"
                                    mb="12px"
                                >
                                    {`${t('Shipment')} ${index + 1}`}
                                </Typography>
                                <ContactRow
                                    label={t('Order')}
                                    value={shipment.order || '-'}
                                    wrap
                                />
                                <ContactRow
                                    label={t('Shipped')}
                                    value={
                                        convertReadableFormatDate(
                                            shipment.shipped,
                                            {
                                                month: 'long',
                                            },
                                        ) || '-'
                                    }
                                />
                                <ContactRow
                                    label={t('Carrier')}
                                    value={shipment.carrier || '-'}
                                />
                            </>
                        )}
                    </Box>
                ))}
            </AccordionDetails>
        </Accordion>
    );
};
